/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_Revoke_EffectInputs */



/**
* | output |
* | --- |
* | "The organization stays dormant and will not activate on {date}. Approval can be given again at any time before then." |
*
* @param {Partner_Org_Contract_Revoke_EffectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_revoke_effect = /** @type {((inputs: Partner_Org_Contract_Revoke_EffectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Revoke_EffectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Organisation bleibt ruhend und wird am ${i?.date} nicht aktiviert. Die Freigabe kann bis dahin jederzeit erneut erteilt werden.`)
	return /** @type {LocalizedString} */ (`The organization stays dormant and will not activate on ${i?.date}. Approval can be given again at any time before then.`)
});